/* Fit Craver — cross-sell (bq-cross.js)
   Updated 2026-09-05: matched by PRODUCT ID, not Arabic title, so it
   works on /he too. Copy switches with <html lang>.

   THE OFFER IS NOT A DISCOUNT. Free shipping already triggers at ₪440,
   so putting two items in ONE order avoids a second shipping fee.
   together   = subtotal + ₪250
   separately = subtotal + ₪250 + (2 x ₪50 shipping)
   ₪50 is the cheapest band, so the saving shown is a FLOOR.
*/
(function () {
  'use strict';

  var HE = (document.documentElement.lang || '').indexOf('he') === 0;
  function t(ar, he) { return HE ? he : ar; }

  var FRENCH = {
    id: 41713862869126,
    productId: '7371483906182',
    price: 25000,
    url: t('/products/%D9%85%D8%B4%D8%AF-%D8%A7%D9%84%D8%B9%D9%88%D8%AF-%D8%A7%D9%84%D9%81%D8%B1%D9%86%D8%B3%D9%8A-%D9%84%D9%84%D8%A8%D8%B7%D9%86',
           '/he/products/%D9%85%D8%B4%D8%AF-%D8%A7%D9%84%D8%B9%D9%88%D8%AF-%D8%A7%D9%84%D9%81%D8%B1%D9%86%D8%B3%D9%8A-%D9%84%D9%84%D8%A8%D8%B7%D9%86'),
    img: 'https://cdn.shopify.com/s/files/1/0610/6041/5622/files/AF14636B-E6DD-4D44-9B9B-E4B9F60344EF.jpg?v=1784107430&width=160'
  };

  var FREE_SHIP_MIN = 44000;   /* ₪440 */
  var SHIP_BAND     = 5000;    /* ₪50, cheapest band */

  /* product id -> [together, separately, isSecondOfSame] */
  var PAGES = {
    '7371483578502': [500, 600, false],   /* Colombian */
    '7371483644038': [549, 649, false],   /* Brazilian */
    '7371483906182': [500, 600, true ]    /* French — offer a second one */
  };

  var TXT = {
    addFrench: t('أضيفي مشد العود الفرنسي للبطن', 'הוסיפי מחוך בטן צרפתי'),
    addSecond: t('أضيفي قطعة ثانية من مشد العود الفرنسي', 'הוסיפי פריט שני של מחוך בטן צרפתי'),
    leadPair:  t('المشدين مع بعض', 'השניים יחד'),
    leadTwo:   t('قطعتين مع بعض', 'שני פריטים יחד'),
    insteadOf: t('بدل', 'במקום'),
    ifApart:   t('لو طلبتي كل واحد لحاله', 'אם תזמיני כל אחד בנפרד'),
    save:      t('بتوفري ₪100 والتوصيل مجاني 🚚', 'חוסכת ₪100 והמשלוח חינם 🚚'),
    addBtn:    t('أضيفيه للسلة', 'הוסיפי לעגלה'),
    adding:    t('جاري الإضافة...', 'מוסיף...'),
    added:     t('تمت الإضافة ✓', 'נוסף ✓'),
    goCart:    t('اذهبي للسلة', 'לעגלת הקניות'),
    openPr:    t('افتحي صفحة المنتج', 'פתחי את דף המוצר'),
    alt:       t('مشد العود الفرنسي للبطن', 'מחוך בטן צרפתי')
  };

  function shekels(a) { return Math.round(a / 100); }
  function cartUrl()  { return HE ? '/he/cart' : '/cart'; }

  function getProductId() {
    var el = document.querySelector('[data-productid]');
    return el ? el.getAttribute('data-productid') : null;
  }

  function offerHTML(o) {
    var title = o.second ? TXT.addSecond : TXT.addFrench;
    var lead  = o.second ? TXT.leadTwo   : TXT.leadPair;
    return '' +
      '<a class="bq-cross__img" href="' + FRENCH.url + '">' +
        '<img src="' + FRENCH.img + '" width="72" height="72" loading="lazy" alt="' + TXT.alt + '">' +
      '</a>' +
      '<div class="bq-cross__body">' +
        '<div class="bq-cross__t">' + title + '</div>' +
        '<div class="bq-cross__p">' + lead + ' <b>₪' + o.together + '</b> ' +
          TXT.insteadOf + ' <s>₪' + o.separately + '</s> ' + TXT.ifApart + ' — ' + TXT.save + '</div>' +
        '<button type="button" class="bq-cross__btn">' + TXT.addBtn + '</button>' +
        '<div class="bq-cross__done" hidden></div>' +
      '</div>';
  }

  function wire(box, goToCart) {
    var btn  = box.querySelector('.bq-cross__btn');
    var done = box.querySelector('.bq-cross__done');
    if (!btn) return;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var old = btn.textContent;
      btn.textContent = TXT.adding;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: FRENCH.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if (goToCart) { window.location.href = cartUrl(); return; }
        btn.hidden = true; done.hidden = false;
        done.innerHTML = TXT.added + ' &nbsp;<a href="' + cartUrl() + '">' + TXT.goCart + '</a>';
      }).catch(function () {
        btn.disabled = false; btn.textContent = old;
        done.hidden = false;
        done.innerHTML = '<a href="' + FRENCH.url + '">' + TXT.openPr + '</a>';
      });
    });
  }

  /* ---------- 1. inline block on the product page ---------- */
  function buildInline() {
    if (document.querySelector('.bq-cross--pdp')) return;
    var cfg = PAGES[getProductId()];
    if (!cfg) return;
    var form = document.querySelector('form.t4s-form__product');
    if (!form || !form.parentNode) return;

    var box = document.createElement('div');
    box.className = 'bq-cross bq-cross--pdp';
    box.innerHTML = offerHTML({ together: cfg[0], separately: cfg[1], second: cfg[2] });
    form.parentNode.insertBefore(box, form.nextSibling);
    wire(box, false);
  }

  /* ---------- 2. inside the cart drawer, after add-to-cart ---------- */
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function injectDrawer(mc) {
    if (!isVisible(mc)) return;
    if (mc.querySelector('.bq-cross--drawer')) return;
    if (mc.getAttribute('data-bq-busy') === '1') return;
    mc.setAttribute('data-bq-busy', '1');

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        mc.removeAttribute('data-bq-busy');
        if (mc.querySelector('.bq-cross--drawer')) return;

        var S = cart.items_subtotal_price;
        if (S >= FREE_SHIP_MIN) return;                  /* already free */
        if (S + FRENCH.price < FREE_SHIP_MIN) return;    /* still would not qualify */

        var hasFrench = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === FRENCH.id) { hasFrench = true; break; }
        }

        var box = document.createElement('div');
        box.className = 'bq-cross bq-cross--drawer';
        box.innerHTML = offerHTML({
          together:   shekels(S + FRENCH.price),
          separately: shekels(S + FRENCH.price + 2 * SHIP_BAND),
          second:     hasFrench
        });

        var host = mc.querySelector('.t4s-drawer__content') || mc.querySelector('form') || mc;
        host.appendChild(box);
        wire(box, true);
      })
      .catch(function () { mc.removeAttribute('data-bq-busy'); });
  }

  function watchDrawer() {
    var mc = document.getElementById('t4s-mini_cart');
    if (!mc || !window.MutationObserver) return;
    new MutationObserver(function () { injectDrawer(mc); })
      .observe(mc, { attributes: true, attributeFilter: ['class', 'style'],
                     childList: true, subtree: true });
    injectDrawer(mc);
  }

  function init() { buildInline(); watchDrawer(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
